import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { FormattedMessage, injectIntl } from "react-intl"
import React from "react"
import { MailchimpEditFormProps } from "../../../common/types/integration"
import IntegrationConfigurationValue from "../../../state/integration/IntegrationConfigurationValue"
import ConfigurationValueComponent from "../ConfigurationValueComponent"
import {
    EXTRA_CONFIGURATION_TOGGLE_KEYS,
    renderConfigurationLabel,
    renderToggleLabel
} from "../../../utils/integration/mailchimp"
import IntlProps from "../../../state/helpers/IntlProps"
import FeatureToggleComponent from "../FeatureToggleComponent"
import Toggle from "react-toggle"

export const MailchimpEditForm = injectIntl((props: MailchimpEditFormProps & IntlProps) => {
    const apiUrl = AppContext.getOptions().apiUrl
    const userID = AppContext.getUserLoggedIn().id
    const url = `${apiUrl}/openid/connect/mailchimp/${userID}?r=/integrations/listing?open=mailchimp`

    if (!props.configurationId) {
        return (
            <div className="col-12 ui-module">
                <div className="form-group row">
                    <label className="col-3 col-form-label text-align-right">
                        <FormattedMessage
                            id="integration.form.edit.mailchimp.connect"
                            defaultMessage="Connect"
                        />
                    </label>
                    <div className="col-9">
                        <a href={url} className="btn btn-secondary">
                            <FormattedMessage
                                id="integration.form.edit.mailchimp.connect_with_mailchimp"
                                defaultMessage="Connect with Mailchimp"
                            />
                        </a>
                    </div>
                </div>
            </div>
        )
    }


    return (
        <div className="col-12 ui-module">
            <div className="form-group row">
                <label className="col-3 col-form-label text-align-right" htmlFor="realmId">
                    <FormattedMessage
                        id="integration.form.edit.mailchimp.account_id"
                        defaultMessage="Account ID"
                    />
                </label>
                <div className="col-9">
                    <input
                        name="accountId"
                        value={props.configuration.accountId}
                        disabled={true}
                        id="accountId"
                        type="text"
                        className="form-control"
                    />
                </div>
            </div>

            {props.configurationValues.map(v => {
                const cv = new IntegrationConfigurationValue(v)
                return (
                    <ConfigurationValueComponent
                        key={cv.getId()}
                        configurationValue={cv}
                        value={props.configuration[cv.getKey()]}
                        onChange={value => {
                            const updatedConfig = props.configuration
                            updatedConfig[cv.getKey()] = value
                            props.onChange({
                                configuration: updatedConfig,
                                enabledFeatures: props.enabledFeatures,
                            })
                        }}
                        hideDefaultOption={false}
                        renderConfigurationValueLabel={renderConfigurationLabel}
                        intl={props.intl}
                    />
                )
            })}

            {EXTRA_CONFIGURATION_TOGGLE_KEYS.map(key => {
                return (
                    <div className="form-group row" key={key}>
                        <label className="col-3 col-form-label text-align-right" htmlFor={key}>
                            {renderToggleLabel(key)}
                        </label>
                        <div className="col-9 d-flex align-items-center">
                            <Toggle
                                icons={false}
                                checked={props.configuration[key]}
                                onChange={() => {
                                    const updatedConfig = props.configuration
                                    updatedConfig[key] = !updatedConfig[key]
                                    props.onChange({
                                        enabledFeatures: props.enabledFeatures,
                                        configuration: updatedConfig,
                                    })
                                }}
                            />
                        </div>
                    </div>

                )
            })}

            {Object.keys(props.enabledFeatures).map(key => {
                return (
                    <>
                        <FeatureToggleComponent
                            checked={props.enabledFeatures[key]}
                            featureKey={key}
                            onFeatureToggled={(featureKey) => {
                                const updatedFeatures = props.enabledFeatures
                                updatedFeatures[featureKey] = !updatedFeatures[featureKey]
                                props.onChange({
                                    configuration: props.configuration,
                                    enabledFeatures: updatedFeatures,
                                })
                            }}
                            renderFeatureLabel={renderToggleLabel}/>
                    </>
                )
            })}


        </div>
    )
})


// WEBPACK FOOTER //
// ./src/integration/form/mailchimp/MailchimpEditForm.tsx